import { SVGProps, Ref, forwardRef } from 'react';

export const ChevronWide3OutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path d="m15.498 12.783-.697 1.215-6.802-3.906-6.8 3.906L.5 12.783 8 8.478z" fill="currentColor" />
            <path d="m15.498 8.797-.697 1.214-6.802-3.907-6.8 3.907L.5 8.797 8 4.49z" fill="currentColor" />
            <path d="m15.498 4.81-.697 1.213-6.802-3.906-6.8 3.906L.5 4.81 8 .502z" fill="currentColor" />
        </g>
    </svg>
));
ChevronWide3OutlinedSize16Glyph.displayName = 'ChevronWide3OutlinedSize16Glyph';
